module.exports = global["$"] = require("-!E:\\Development\\AK\\bb-code\\BB.Web\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-wizard/node_modules/jquery/dist/jquery.js
// module id = 24Wi
// module chunks = 1